export function concatAxiosTransformer(t, ...nt) {
    // If undefined just return nt
    if (t === undefined) {
        return nt;
    }
    // If isArray than existing transformers need to come first in the array
    if (Array.isArray(t)) {
        return t.concat(...nt);
    }
    // If type is AxiosTransformer then just set it as first element in nt
    nt.unshift(t);
    return nt;
}
